var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-bar mb-3 my-2 my-sm-0",staticStyle:{"min-width":"400px"}},[_c('amf-search-box',{attrs:{"search":_vm.search,"show-clear-button":_vm.showClearButton,"optionsComponent":"system-search-options"},on:{"select":_vm.select,"clear":_vm.clear}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82f7ebac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/framework/SystemSearchBar.vue
// module id = null
// module chunks = 